<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col class="header-title mr-1" cols="11">
                    <span class="header-title-content">مدیریت توضیحات و ملاحظات</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن توضیح
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card height="74vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" v-for="(item, index) in preDefinedNotesFilteredList" :key="item.id">
                      <div class="items-back"></div>
                      <v-row no-gutters>
                        <v-col cols="1"></v-col>
                        <v-col cols="11">
                          <v-card height="11vh" class="mt-4 mr-n15">
                            <v-row no-gutters>
                              <v-col cols="1">
                                <v-row class="items-space" no-gutters></v-row>
                                <v-row no-gutters>
                                  <v-col cols="12" class="items-circle">
                                    <v-row class="items-space-above" no-gutters></v-row>
                                    <v-row no-gutters>
                                      <v-col cols="5" class="items-circle-above">
                                        <v-row no-gutters>
                                          <v-col cols="12" class="text-center items-index-space">
                                            <span class="items-index">{{ index + 1 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-spacer></v-spacer>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="10" v-if="item.isEdit == false" class="items-card-text-space">
                                <span>{{ item.title }}</span>
                              </v-col>
                              <v-col cols="1" class="items-card-text-space" v-if="item.isEdit == false">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="darkColor" style="cursor: pointer"
                                      @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                      mdi-pencil mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>ویرایش</span>
                                </v-tooltip>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon class="mr-3" color="darkColor" style="cursor: pointer"
                                      @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                      mdi-delete mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>حذف</span>
                                </v-tooltip>
                              </v-col>
                              <v-col cols="10" v-if="item.isEdit == true">
                                <v-text-field type="text" v-model="preDefinedNote.title"
                                  v-on:keyup.enter="showConfirmDialogFunction()" label="متن" :autofocus="true"
                                  tabindex="1" append-icon="mdi-close-circle" append-outer-icon="mdi-check-all"
                                  @click:append="cancelAddEditFunction(item.id)"
                                  @click:append-outer="showConfirmDialogFunction()"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4">
                      <div class="items-back-add"></div>
                      <v-row>
                        <v-col cols="1"></v-col>
                        <v-col cols="10">
                          <v-card height="11vh" class="mt-4 mr-2 item-add-card">
                            <v-row no-gutters>
                              <v-col cols="2">
                                <v-row class="items-space" no-gutters></v-row>
                                <v-row no-gutters>
                                  <v-col cols="12" class="items-circle">
                                    <v-row class="items-space-above" no-gutters></v-row>
                                    <v-row no-gutters>
                                      <v-col cols="8" class="items-circle-above-add text-center">
                                        <v-row no-gutters>
                                          <v-col cols="12" class="text-center items-index-space">
                                            <span class="items-index">
                                              {{ allPreDefinedNotes.length + 1 }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-spacer></v-spacer>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col class="items-card-text-space">
                                <span>متن:</span>
                              </v-col>
                              <v-spacer></v-spacer>
                              <v-col cols="1" class="items-card-text-space">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="darkColor" style="cursor: pointer"
                                      @click="enableAddEditFunction(1, 0)" v-bind="attrs" v-on="on">
                                      mdi-plus mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>افزودن</span>
                                </v-tooltip>
                              </v-col>
                              <v-col cols="1"></v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import pagination from '@/Mixins/Pagination';
import preDefinedNoteMixin from '@/Mixins/BaseInformation/PreDefinedNoteMixin';
import preDefinedNoteHelper from '@/Helpers/BaseInformation/PreDefinedNoteHelper';
export default {
  name: 'PreDefinedNoteManagment',
  title: 'توضیحات و ملاحظات',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
  },
  mixins: [pagination, ShearedMixin, preDefinedNoteMixin, preDefinedNoteHelper, snackBar],
  created() {
    this.$root.$refs.PreDefinedNoteManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.getAllPreDefinedNotes();
    },
  },
  computed: {
    preDefinedNotesFilteredList() {
      return this.allPreDefinedNotes.filter((u) => {
        return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
      });
    },
  },
};
</script>
<style scoped>
.items-back {
  background: var(--dark-color) !important;
  position: absolute;
  height: 15vh;
  width: 13%;
  border-radius: 14px !important;
}

.items-back-add {
  background: var(--one-field-color) !important;
  position: absolute;
  height: 15vh;
  width: 13%;
  border-radius: 14px !important;
}

.items-circle {
  width: 7.5vh;
  height: 7.5vh;
  border-radius: 50% !important;
  background: white;
  margin-right: -3.7vh;
}

.items-space {
  height: 1.75vh;
}

.items-circle-above {
  width: 5vh;
  height: 5vh;
  border-radius: 50% !important;
  background: var(--dark-color);
  margin-right: 1vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-circle-above-add {
  width: 5vh;
  height: 5vh;
  border-radius: 50% !important;
  background: var(--one-field-color);
  margin-right: 1vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-space-above {
  height: 1.2vh;
}

.items-index {
  color: white;
}

.items-index-space {
  margin-top: 1.3vh !important;
}

.items-card-text-space {
  margin-top: 4vh;
}

.item-add-card {
  border: 2px dashed #c0d1e2 !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
